<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <div class="content-wrapper">
      <div class="app">
        <br />
        <h3 class="title cor-preta">Produto selecionado:</h3>
        <div>
          <div
            style="
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              flex-direction: column;
            "
          >
            <label class="cor-preta">
              <b>{{ product.nm }}</b>
            </label>
            <label class="cor-cinza" style="padding: 5px">
              <b>{{ product.ingredientes }}</b>
            </label>
            <label class="cor-preta">
            <span v-if="product.vl_promo > 0">
              <b>R$ {{ product.vl_promo }}</b>
            </span>
            <span v-else>
              <b>R$ {{ product.vl }} </b>
            </span>
            </label>
          </div>
          <br />
          <div class="col-md-14">
            <div>
              <label class="cor-preta"
                ><b>{{ nome_ordens[index].nm }}</b></label
              ><br />
            </div>
          </div>
          <div>
            <label class="cor-preta"
              ><b class="letra-pequena"
                >Mínima :
                {{ formatarSelecao(nome_ordens[index].selecao_min) }}</b
              ></label
            >
            <label class="cor-preta"
              ><b class="letra-pequena"
                >Máxima :
                {{ formatarSelecao(nome_ordens[index].selecao_max) }}</b
              ></label
            >
          </div>
          <div id="listandoordem">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">
                    <label class="cor-preta"><b></b></label>
                  </th>
                  <th scope="col">
                    <label class="cor-preta"><b>Opções</b></label>
                  </th>
                  <th scope="col">
                    <label class="cor-preta"><b>Preço</b></label>
                  </th>
                </tr>
              </thead>
              <tbody v-for="adicional of adicionais" :key="adicional.cd">
                <tr>
                  <td align="center">
                    <input
                      type="checkbox"
                      :id="adicional"
                      :value="adicional"
                      v-model="checkedNames"
                    />
                  </td>
                  <td>{{ adicional.nm }}</td>
                  <td>R$ {{ adicional.vl }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <div v-if="index === nome_ordens.length - 1">
            <b>Alguma observação ?</b>
            <textarea
              class="form-control"
              v-model="obs"
              id="obs"
              name="obs"
              rows="1"
              placeholder="Ex: Digite as observações aqui..."
            ></textarea>

            <br />
            <table border="0">
              <thead>
                <tr>
                  <td width="350" valign="top">
                    <li align="left" v-if="index > 0">
                      <button
                        style="background-color: #dc3545"
                        @click="menosindex(checkedNames, adicionaispergunta)"
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                    <li v-else-if="verificarPizza()">
                      <button
                        style="background-color: #dc3545"
                        @click="pushVoltar()"
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                  </td>
                  <td width="100">
                    <li align="center"></li>
                  </td>
                  <td width="480" valign="top">
                    <li align="right">
                      <button
                        style="background-color: #006400"
                        @click="
                          somaadicionais(
                            checkedNames,
                            adicionaispergunta,
                            nome_ordens,
                            product,
                            obs
                          )
                        "
                        type="button"
                        class="btn btn-dark"
                      >
                        Continuar
                      </button>
                    </li>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
          <div v-else>
            <table border="0">
              <thead>
                <tr>
                  <td width="350" valign="top">
                    <li align="left" v-if="index > 0">
                      <button
                        style="background-color: #dc3545"
                        @click="
                          menosindex(
                            checkedNames,
                            adicionaispergunta,
                            nome_ordens
                          )
                        "
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                    <li v-else-if="verificarPizza()">
                      <button
                        style="background-color: #dc3545"
                        @click="pushVoltar()"
                        type="button"
                        class="btn btn-dark"
                      >
                        Voltar
                      </button>
                    </li>
                  </td>
                  <td width="100">
                    <li align="center"></li>
                  </td>
                  <td width="480" valign="top">
                    <li align="right">
                      <button
                        style="background-color: #006400"
                        @click="
                          somaindex(
                            checkedNames,
                            adicionaispergunta,
                            nome_ordens
                          )
                        "
                        type="button"
                        class="btn btn-dark"
                      >
                        Continuar
                      </button>
                    </li>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
    <br />
    <footer class="main-footer" align="center">
      <b class="cor-preta">Todos os direitos reservados.</b><br />
      <b class="cor-preta"
        >&copy; 2022
        <a target="”_blank”" href="https://www.panterafood.com.br"
          >Pantera Food</a
        >.</b
      ><br />
      <img
        width="100"
        src="https://apppanterafood.com.br/DeliveryCenter/3/logo/pantera.svg"
      />
    </footer>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Adicional from "../services/adicional";
import Ordem from "../services/nome_ordem";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Perguntas",
  data() {
    return {
      obs: [],
      product: [],
      checkedNames: [],
      adicionaispergunta: [],
      search: "",
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
        vl_promo: "",
      },
      nome_ordens: [],
      nome_ordem: {
        cd: "",
        nm: "",
        ordem: "",
        cd_prod: "",
        selecao_min: "",
        selecao_max: "",
      },
      adicionais: [],
      adicional: {
        cd: "",
        cd_prod: "",
        qtd: "",
        vl: "",
        tipo: "",
        nm: "",
        cd_sabor: "",
        ordem: "",
        obs: "",
        cd_prod_pai: "",
      },
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      cdproduto: "",
      nmproduto: "",
      vlproduto: "",
      ingredientesproduto: "",
      classeproduto: "",
      index: 0,
      obj: [],
    };
  },
  computed: {
    ...mapGetters({
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    verificarPizza() {
      if (this.product.classe == "PIZZAS") {
        return true;
      } else {
        return false;
      }
    },
    pushVoltar() {
      this.$router.push("/pizzas");
    },
    listarproduto() {
      this.product = ls.get("product" + process.env.VUE_APP_CONTRATO);

      //alert('Produto Selecionado Adicional: '+this.product);

      Ordem.verificaordem(this.product.cd).then((resposta) => {
        this.nome_ordens = resposta.data.filter((nm_ordem) => {
          return nm_ordem.ativo == "1";
        });

        Adicional.verificaadicional(
          this.product.cd,
          this.nome_ordens[0].ordem
        ).then((resposta) => {
          this.adicionais = resposta.data.filter((adicional) => {
            return adicional.ativo == "1";
          });
          /* alert(JSON.stringify(this.product.cd));
        alert(JSON.stringify(this.nome_ordens)); */
        });
      });
    },
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
    },
    formatarSelecao(selecao) {
      if (selecao == "0") {
        return "Nenhum";
      } else if (selecao == "-1") {
        return "Ilimitado";
      } else {
        return selecao;
      }
    },

    //menos index
    menosindex(checkedNames, adicionaispergunta) {
      this.index = 0;
      //alert(JSON.stringify(index));
      this.checkedNames = [];
      this.adicionaispergunta = [];
      /* 		checkedNames.pop();
  	
    adicionaispergunta.pop(); */

      Adicional.verificaadicional(
        this.product.cd,
        this.nome_ordens[this.index].ordem
      ).then((resposta) => {
        this.adicionais = resposta.data;

        //alert(JSON.stringify(resposta.data));
      });

      /*checkedNames.forEach((item) => {
      this.adicionaispergunta.push(item);
    })*/

      //alert(JSON.stringify(this.adicionaispergunta));

      while (checkedNames.length) {
        checkedNames.pop();
      }
      if (this.verificarPizza() == true) {
        this.$router.push("/pizzas");
      }
    },

    somaadicionais(
      checkedNames,
      adicionaispergunta,
      nome_ordens,
      product,
      obs
    ) {
      var d1 = this.$store.state.date_token;
      var d2 = moment().format("YYYY-MM-DD hh:mm:ss");
      var diff = moment(d2, "YYYY-MM-DD HH:mm:ss").diff(
        moment(d1, "YYYY-MM-DD HH:mm:ss")
      );
      diff = diff / 60000;
      //console.log(this.adicionaispergunta, "somaAdicional");
      if (
        checkedNames.length > nome_ordens[this.index].selecao_max &&
        nome_ordens[this.index].selecao_max != "-1"
      ) {
        Swal.fire({
          title:
            "Você pode selecionar no máximo " +
            nome_ordens[this.index].selecao_max +
            " item(s).",
          confirmButtonColor: "#000000",
        });
        /* alert(
          "Você pode selecionar no máximo " +
            nome_ordens[this.index].selecao +
            " item(s)."
        ); */
        return false;
      } else if (checkedNames.length < nome_ordens[this.index].selecao_min) {
        Swal.fire({
          title:
            "Você pode selecionar no mínimo " +
            nome_ordens[this.index].selecao_min +
            " item(s).",
          confirmButtonColor: "#000000",
        });
        return false;
      }
      /*       else if (checkedNames.length == 0) {
              Swal.fire({
                title: "Selecione pelo menos uma opção.",
                confirmButtonColor: "#000000",
              });
              //alert("Selecione pelo menos uma opção.");
              return false;
            } */

      checkedNames.forEach((item) => {
        if (item.tipo === "M") {
          item.nm = "s/" + item.nm;
        } else if (item.tipo === "D") {
          item.nm = "c/" + item.nm;
        }
        this.adicionaispergunta.push(item);
      });

      //alert(JSON.stringify(this.adicionaispergunta));
      /*       const inis = this.inis; */

      if (this.$store.state.funcionamento === "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
        //alert("Estabelecimento Fechado");
      } else if (diff > 30) {
        Swal.fire({
          title: "Tempo de conexão expirou! Leia o QRcode novamente!",
          confirmButtonColor: "#000000",
        });
      } else if (this.$store.state.funcionamento === "1") {
        if (this.product.classe == "PIZZAS") {
          this.obj = ls.get("sabores" + process.env.VUE_APP_CONTRATO);
          adicionaispergunta = this.obj.concat(adicionaispergunta);
          this.inis.forEach((inis) => {
            if (inis.vl === "3" || inis.vl === "2") {
              product.vl = 0;
            }
          });
        }

        if (this.obs != "") {
          if (adicionaispergunta.length == 0) {
            adicionaispergunta.push({
              nm: "",
              qtd: 1,
              vl: 0,
            });
          }

          if (
            adicionaispergunta[adicionaispergunta.length - 1].nm.length +
              this.obs.length >=
            250
          ) {
            Swal.fire({
              title: "Limite de caracteres na observação atingido",
              confirmButtonColor: "#000000",
            });
          } else {
            adicionaispergunta[adicionaispergunta.length - 1].nm =
              adicionaispergunta[adicionaispergunta.length - 1].nm +
              " | obs: " +
              this.obs;
          }
        }
        this.$store.dispatch("addToCart", {
          product,
          adicionaispergunta,
          obs,
        });
        /* addToCart({product, adicionaispergunta, obs}) */
        this.$router.push("/cart");
        while (checkedNames.length) {
          checkedNames.pop();
        }
      }
    },

    //somar index
    somaindex(checkedNames, adicionaispergunta, nome_ordens) {
      if (
        checkedNames.length > nome_ordens[this.index].selecao_max &&
        nome_ordens[this.index].selecao_max != "-1"
      ) {
        Swal.fire({
          title:
            "Você pode selecionar no máximo " +
            nome_ordens[this.index].selecao_max +
            " item(s).",
          confirmButtonColor: "#000000",
        });
        /* alert(
          "Você pode selecionar no máximo " +
            nome_ordens[this.index].selecao +
            " item(s)."
        ); */
        return false;
      } else if (checkedNames.length < nome_ordens[this.index].selecao_min) {
        Swal.fire({
          title:
            "Você pode selecionar no mínimo " +
            nome_ordens[this.index].selecao_min +
            " item(s).",
          confirmButtonColor: "#000000",
        });
        return false;
      }
      /*       else if (checkedNames.length == 0) {
              Swal.fire({
                title: "Selecione pelo menos uma opção.",
                confirmButtonColor: "#000000",
              });
              //alert("Selecione pelo menos uma opção.");
              return false;
            } */

      this.index += 1;
      //alert(this.index);

      checkedNames.forEach((item) => {
        if (item.tipo === "M") {
          item.nm = "s/" + item.nm;
        } else if (item.tipo === "D") {
          item.nm = "c/" + item.nm;
        }
        this.adicionaispergunta.push(item);
      });

      //alert(JSON.stringify(this.product.cd));
      //alert(JSON.stringify(this.nome_ordens[this.index].ordem));

      Adicional.verificaadicional(
        this.product.cd,
        this.nome_ordens[this.index].ordem
      ).then((resposta) => {
        this.adicionais = resposta.data;

        //alert(JSON.stringify(resposta.data));
      });

      while (checkedNames.length) {
        checkedNames.pop();
      }
    },

    //verificaselecao
    verificaselecao(checkedNames, nome_ordens) {
      if (
        checkedNames.length === 0 ||
        checkedNames.length === "" ||
        checkedNames.length == null
      ) {
        Swal.fire({
          title: "Selecione pelo menos uma opção.",
          confirmButtonColor: "#000000",
        });
        //alert("Selecione pelo menos uma opção.");
      } else {
        if (checkedNames.length > nome_ordens) {
          Swal.fire({
            title:
              "Você pode selecionar no máximo " + nome_ordens + " item(s).",
            confirmButtonColor: "#000000",
          });
          //alert("Você pode selecionar no máximo " + nome_ordens + " item(s).");
        } else {
          return false;
        }
      }
    },

    ...mapActions(["addToCart"]),
  },
  mounted() {
    this.listarproduto(), this.listarinis();
  },
};
</script>
